import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { ShepherdService } from 'angular-shepherd';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-home-tour',
  standalone: true,
  imports: [],
  templateUrl: './home-tour.component.html',
  styleUrl: './home-tour.component.scss'
})
export class HomeTourComponent implements AfterViewInit {

  private cookieName: string = 'home-tour';

  hideRestartLink: boolean = false;
  constructor(private shepherdService: ShepherdService, private cookieService: CookieService, private router: Router) { }

  ngAfterViewInit(): void {
    
  }


  async startTour() {
    if (this.router.url !== "/") {
      await this.router.navigateByUrl("/");
    }

    let defaultSteps: any = [
      {
        id: 'step1a',
        attachTo: {
          element: '.image-analyzer-button-mobile',
          on: 'bottom'
        }, showOn: () => this.isElementVisible('.image-analyzer-button-mobile'),
        buttons: [
          {
            classes: 'shepherd-button-primary',
            text: 'Next',
            type: 'next'
          }
        ],
        classes: '',
        highlightClass: 'highlight',
        scrollTo: false,
        title: 'NEW! Image Analyzer',
        text:
          `GT Pro Tune now includes an enhanced image analyzer.
            You can provide screenshots from GT7 to automatically read most of the values needed for tuning.`
        ,
      },
      {
        id: 'step1b',
        attachTo: {
          element: '.image-analyzer-button',
          on: 'right'
        }, showOn: () => this.isElementVisible('.image-analyzer-button'),
        title: 'NEW! Image Analyzer',
        text:
          `GT Pro Tune now includes an enhanced image analyzer.
            You can provide screenshots from GT7 to automatically read most of the values needed for tuning.`,
        buttons: [
          {
            classes: 'shepherd-button-primary',
            text: 'Next',
            type: 'next'
          }
        ]
      },
      {
        id: 'step2',
        attachTo: {
          element: '.race-engineer-button',
          on: 'top'
        },
        title: 'NEW! AI Race Engineer',
        text:
          `Harness the power of AI to enhance your tunes.`,
        buttons: [
          {
            classes: 'shepherd-button-primary',
            text: 'Back',
            type: 'back'
          },
          {
            classes: 'shepherd-button-primary',
            text: 'Next',
            type: 'next'
          }
        ]
      },
      {
        id: 'step3',
        attachTo: {
          element: '.race-engineer-button',
          on: 'top'
        },
        title: 'NEW! AI Race Engineer',
        text:
          `With an optional monthly subscription, you can chat with an AI race engineer.
            Go to Manage Profile to subscribe.`,
        buttons: [
          {
            classes: 'shepherd-button-primary',
            text: 'Back',
            type: 'back'
          },
          {
            classes: 'shepherd-button-primary',
            text: 'Close',
            type: 'next'
          }
        ]
      }
    ]
    //this.shepherdService.defaultStepOptions = defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.confirmCancel = false;
    this.shepherdService.onTourFinish = () => {
      this.cookieService.set(this.cookieName, `completed:${new Date()}`);
      this.hideRestartLink = false;
    };
    this.shepherdService.addSteps(defaultSteps);
    this.shepherdService.start();
  }

  isElementVisible(selector: string) {
    const element = document.querySelector(selector) as HTMLElement;

    return element &&
      element.offsetParent !== null &&
      window.getComputedStyle(element).visibility !== 'hidden';
  }
}
